export default {
    meta: {
        title: '安全登录',
        isShowHeader: false,
    },
};
